import { mutate as globalMutate } from 'swr'

const keyPath = (key) => Array.isArray(key) ? key[0] : key
const matchesPath = (key, prefix) => {
  const path = keyPath(key)
  return typeof path === 'string' && path.startsWith(prefix)
}

const isOfferListKey = (key) => [
  '/offer/search?',
  '/offer/top10clicks?',
  '/offer/popular?',
  '/favorite?',
].some((prefix) => matchesPath(key, prefix))

const updateOffer = (offer, offerId, claimsRemaining) => (
  offer?.id === offerId ? { ...offer, claimsRemaining } : offer
)

const updateOfferCollection = (data, offerId, claimsRemaining) => {
  if (Array.isArray(data)) {
    return data.map((offer) => updateOffer(offer, offerId, claimsRemaining))
  }
  if (!data || !Array.isArray(data.content)) return data
  return {
    ...data,
    content: data.content.map((offer) => updateOffer(offer, offerId, claimsRemaining)),
  }
}

export const updateCachedClaimsRemaining = (offerId, claimsRemaining, mutate = globalMutate) => mutate(
  isOfferListKey,
  (data) => updateOfferCollection(data, offerId, claimsRemaining),
  { revalidate: false }
)

export const removeCachedFavorite = (offerId, mutate = globalMutate) => mutate(
  (key) => matchesPath(key, '/favorite?'),
  (data) => {
    if (!data || !Array.isArray(data.content)) return data
    const content = data.content.filter((offer) => offer.id !== offerId)
    const removed = data.content.length - content.length
    return removed ? {
      ...data,
      content,
      totalElements: Math.max(0, (data.totalElements || 0) - removed),
    } : data
  },
  { revalidate: false }
)

export const revalidateFavoriteOffers = (mutate = globalMutate) => mutate(
  (key) => matchesPath(key, '/favorite?')
)

export const revalidateClaimHistory = (mutate = globalMutate) => mutate(
  (key) => matchesPath(key, '/user/claims?')
)
